import { useCallback, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import Search from "@/design/components/Search";
import useSearch from "@/utils/hooks/useSearch";
import Valkyrie, { viPlus, viXmark } from "@sippy-platform/valkyrie";

import { Box, Button, Drawer, IconButton, List, ListItem, ListItemText, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import AddPbxItem from "./AddPbxItem";

function PbxFlyout({ account, accountDispatch, accountPbxList }) {
  const pbxStore = useSelector((state) => state.backstage.pbxes);

  const assignablePbxList = useMemo(
    () => pbxStore.list.filter((_pbx) => !accountPbxList.some((_filter) => _filter.id === _pbx.id)),
    [accountPbxList, pbxStore],
  );

  // Drawer
  const [drawer, setDrawer] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  const searchResults = useSearch(assignablePbxList, searchValue, ["context", "name"]);

  const closeDrawer = useCallback(() => {
    setDrawer(undefined);
    setSearchValue("");
  }, []);

  return (
    <>
      <Button onClick={() => setDrawer(true)} startIcon={<Valkyrie icon={viPlus} />} variant="contained">
        Add
      </Button>
      <Drawer
        open={!!drawer}
        onClose={() => closeDrawer()}
        anchor="right"
        slotProps={{
          paper: {
            sx: (theme) => ({ maxWidth: 320, width: 1, p: 1.5, display: "flex", gap: 1, ...theme.scrollbar }),
            elevation: 4,
          },
        }}
      >
        <Stack
          direction="row"
          sx={{
            gap: 1,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">Connect PBX</Typography>
          <IconButton onClick={() => closeDrawer()} color="inherit">
            <Valkyrie icon={viXmark} />
          </IconButton>
        </Stack>
        <Box sx={{ position: "sticky", top: 0, zIndex: 1000 }}>
          <Search blur value={searchValue} onChange={setSearchValue} />
        </Box>
        <List>
          {searchResults.length >= 1 ? (
            searchResults.map((pbx, key) => (
              <AddPbxItem account={account} accountDispatch={accountDispatch} pbx={pbx} key={key} />
            ))
          ) : (
            <ListItem>
              <ListItemText primary="No PBXes available" />
            </ListItem>
          )}
        </List>
      </Drawer>
    </>
  );
}

PbxFlyout.propTypes = {
  account: PropTypes.object,
  accountDispatch: PropTypes.func,
  accountPbxList: PropTypes.array,
};

export default PbxFlyout;
